module.exports = __webpack_public_path__ + "img/tutorial_redactions_03.6c4f18f1.gif";